import React from 'react';

import styles from './styles/type-box.module.css';

import {ReactComponent as MariaDB} from '../../../../../assets/db-connect/maria-db.svg';
import {ReactComponent as MySQL} from '../../../../../assets/db-connect/my-sql.svg';
import {ReactComponent as MSSQL} from '../../../../../assets/db-connect/ms-sql.svg';
import {ReactComponent as PostgreSQL} from '../../../../../assets/db-connect/postgre-sql.svg';
import {ReactComponent as Oracle} from '../../../../../assets/db-connect/oracle.svg';
import {ReactComponent as SQLLite} from '../../../../../assets/db-connect/sql-lite.svg';
import {ReactComponent as DLogoMedium} from '../../../../../assets/logo/d-logo-md.svg';

export default function TypeBox({ step, dbType, setCurrentStepName, changeConnectionInfo }) {
    const typeMap = [
        { name: 'MariaDB', value: 'MARIADB', portNumber: '3306', Icon: MariaDB },
        { name: 'MySQL', value: 'MYSQL', portNumber: '3306', Icon: MySQL },
        { name: 'MSSQL', value: 'MSSQL', portNumber: '1433', Icon: MSSQL },
        { name: 'PostgreSQL', value: 'POSTGRESQL', portNumber: '5432', Icon: PostgreSQL },
        { name: 'Oracle', value: 'ORACLE', portNumber: '1521', Icon: Oracle },
        { name: 'SQLite', value: 'SQLITE', portNumber: '', Icon: SQLLite },
        { name: 'DARVIS', value: 'DARVIS', portNumber: '', Icon: DLogoMedium }
    ];

    const targetItem = typeMap.find(item => item.value === dbType);

    const { name, value, portNumber, Icon } = targetItem;

    const clickTypeBox = () => {
        changeConnectionInfo('dbType', value);
        changeConnectionInfo('portNumber', portNumber);
        setCurrentStepName('info');
    };

    return (
        <div
            className={styles.wrapper}
            data-type={step}
            onClick={clickTypeBox}
        >
            <Icon />
            <p>{name}</p>
        </div>
    );
}
